// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1CBJ4","header":"ReportDetails_header__1rfd0","title":"ReportDetails_title__2IhpL","left":"ReportDetails_left__3ktfR"};